import React, { useMemo, useRef } from "react";
import ReactECharts from "echarts-for-react";
import styles from "./DateBrush.module.css";

export default function DateBrush({ data, dates, range, onChange }) {
    const chartRef = useRef(null);

    const totals = useMemo(() => {
        const map = new Map(dates.map(d => [d, 0]));
        data.forEach(d => {
            map.set(d.date, (map.get(d.date) || 0) + (d.cnt || 0));
        });
        return dates.map(d => map.get(d) || 0);
    }, [data, dates]);

    const startPct =
        dates.length > 1
            ? (dates.indexOf(range.from) / (dates.length - 1)) * 100
            : 0;

    const endPct =
        dates.length > 1
            ? (dates.indexOf(range.to) / (dates.length - 1)) * 100
            : 100;

    const option = {
        animation: false,

        grid: {
            left: 40,
            right: 40,
            top: 8,
            bottom: 26
        },

        xAxis: {
            type: "category",
            data: dates,
            boundaryGap: false,
            axisLabel: { show: false },
            axisTick: { show: false },
            axisLine: { show: false }
        },

        yAxis: {
            type: "value",
            min: 0,
            boundaryGap: [0.2, 0.2],
            axisLabel: { show: false },
            splitLine: { show: false }
        },

        dataZoom: [
            {
                type: "slider",
                start: startPct,
                end: endPct,
                bottom: 6,
                height: 16,
                handleSize: 20,
                showDetail: false,
                backgroundColor: "#e5e7eb",
                fillerColor: "rgba(59,130,246,0.25)",
                borderColor: "transparent"
            }
        ],

        series: [
            {
                type: "line",
                data: totals,
                smooth: true,
                symbol: "none",
                clip: false,
                lineStyle: { width: 2, color: "#3b82f6" },
                areaStyle: { opacity: 0.15 }
            }
        ]
    };

    const onEvents = {
        datazoom: () => {
            const inst = chartRef.current?.getEchartsInstance();
            const dz = inst?.getOption()?.dataZoom?.[0];
            if (!dz) return;

            const n = dates.length - 1;
            const from = dates[Math.round((dz.start / 100) * n)];
            const to = dates[Math.round((dz.end / 100) * n)];

            onChange({
                from: from <= to ? from : to,
                to: from <= to ? to : from
            });
        }
    };

    return (
        <div className={styles.wrapper}>
            <ReactECharts
                ref={chartRef}
                option={option}
                onEvents={onEvents}
                style={{ height: 72, width: "100%" }}
                opts={{ height: 72 }}
            />

            <div className={styles.rangeLabels}>
                <span>{range.from}</span>
                <span>{range.to}</span>
            </div>
        </div>
    );

}
